import type { QueryLazyOptions } from '@apollo/client';
import * as React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export function useWithCaptcha<T = any>(
  lazyQuery: (options?: QueryLazyOptions<T>) => void,
) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isRobot, setIsRobot] = React.useState(false);
  const [isLoadingGoogleReCaptcha, setIsLoadingGoogleReCaptcha] =
    React.useState(false);
  const func = React.useCallback(
    async (options?: QueryLazyOptions<T>) => {
      const result = await executeRecaptcha?.('dynamicAction');
      setIsLoadingGoogleReCaptcha(true);
      const data = await fetch('/api/googleReCaptchaVerify', {
        method: 'post',
        body: JSON.stringify({ captcha: result }),
      });
      setIsLoadingGoogleReCaptcha(false);
      const googleReCaptchaVerifyResponse = await data.json();
      setIsRobot(!googleReCaptchaVerifyResponse.success);
      if (googleReCaptchaVerifyResponse.success) {
        lazyQuery(options);
      }
    },
    [executeRecaptcha, lazyQuery, setIsRobot, setIsLoadingGoogleReCaptcha],
  );

  return { func, isRobot, isLoadingGoogleReCaptcha };
}
